export default "__VITE_ASSET__hO7VBBXnOl1k4ErpMlvAaA__"